module.exports = __webpack_public_path__ + "img/phone-top.f47ba828.svg";